


  
  

  var faCircleInfo = {
    prefix: 'fasr',
    iconName: 'circle-info',
    icon: [
      512,
      512,
      ["info-circle"],
      'f05a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l-24 0 0 48 24 0 80 0 24 0 0-48-24 0-8 0 0-88 0-24-24 0-48 0-24 0 0 48 24 0 24 0 0 64-24 0zm72-144l0-64-64 0 0 64 64 0z'
      
    ]
  };

  
    var faInfoCircle = faCircleInfo;
  

  
  

  var faLightbulbOn = {
    prefix: 'fasr',
    iconName: 'lightbulb-on',
    icon: [
      640,
      512,
      [],
      'f672',
      
      'M448 176c0 27.2-8.4 52.3-22.8 72.9c-3.7 5.3-8 11.3-12.7 17.7c0 0 0 0 0 0s0 0 0 0s0 0 0 0s0 0 0 0c-12.9 17.7-28.3 38.9-39.8 59.8c-10.4 19-15.7 38.8-18.3 57.5l48.6 0c2.2-12 5.9-23.7 11.8-34.5c9.9-18 22.2-34.9 34.5-51.8c0 0 0 0 0 0s0 0 0 0s0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C496 78.8 417.2 0 320 0S144 78.8 144 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0s0 0 0 0c12.3 16.8 24.6 33.7 34.5 51.8c5.9 10.8 9.6 22.5 11.8 34.5l48.6 0c-2.6-18.7-7.9-38.6-18.3-57.5c-11.5-20.9-26.9-42.1-39.8-59.8c0 0 0 0 0 0s0 0 0 0c-4.7-6.4-9-12.4-12.8-17.7C200.4 228.3 192 203.2 192 176c0-70.7 57.3-128 128-128s128 57.3 128 128zm-176 0c0-26.5 21.5-48 48-48l0-32c-44.2 0-80 35.8-80 80l32 0zM240 512l160 0 0-96-160 0 0 96zM87.3 16L67.3 2.7 40.7 42.7 60.7 56l6 4 24 16 20 13.3 26.6-39.9L117.3 36l-24-16-6-4zM579.3 56l20-13.3L572.7 2.7 552.7 16l-6 4-24 16-20 13.3 26.6 39.9 20-13.3 24-16 6-4zM24 160L0 160l0 48 24 0 48 0 24 0 0-48-24 0-48 0zm544 0l-24 0 0 48 24 0 48 0 24 0 0-48-24 0-48 0zM117.3 332l20-13.3-26.6-39.9L90.7 292l-24 16-6 4-20 13.3 26.6 39.9 20-13.3 6-4 24-16zm432-39.9l-20-13.3-26.6 39.9 20 13.3 24 16 6 4 20 13.3 26.6-39.9-20-13.3-6-4-24-16z'
      
    ]
  };

  

  
  

  var faArrowDownTriangleSquare = {
    prefix: 'fasr',
    iconName: 'arrow-down-triangle-square',
    icon: [
      576,
      512,
      ["sort-shapes-down"],
      'f888',
      
      'M160 478.7l-17-17-96-96-17-17L64 314.9l17 17 55 55L136 56l0-24 48 0 0 24 0 330.9 55-55 17-17 33.9 33.9-17 17-96 96-17 17zM296 224l30-48 61.7-98.7L416 32l28.3 45.3L506 176l30 48-56.6 0-126.8 0L296 224zm86.6-48l66.8 0L416 122.6 382.6 176zM368 432l96 0 0-96-96 0 0 96zM320 288l48 0 96 0 48 0 0 48 0 96 0 48-48 0-96 0-48 0 0-48 0-96 0-48z'
      
    ]
  };

  
    var faSortShapesDown = faArrowDownTriangleSquare;
  

  
  

  var faCircleDot = {
    prefix: 'fasr',
    iconName: 'circle-dot',
    icon: [
      512,
      512,
      [128280,"dot-circle"],
      'f192',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-96a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  
    var faDotCircle = faCircleDot;
  

  
  

  var faHeadSideBrain = {
    prefix: 'fasr',
    iconName: 'head-side-brain',
    icon: [
      512,
      512,
      [],
      'f808',
      
      'M112 361.7l0 19.6 0 66.8 0 16 0 48-16 0-32 0 0-32 0-16 0-82.8c-41-41.9-64-98.3-64-157C0 100.6 100.2 0 224 0l32 0C357.8 0 441.1 79.2 447.6 179.4l56.3 63.4 8.1 9.1 0 12.2 0 24 0 16 0 32-16 0-16 0-16 0-16 0 0 48 0 16 0 16 0 32-32 0-16 0-32 0-48 0 0 16 0 16 0 16 0 16-32 0-16 0 0-48 0-16 0-48 48 0 80 0 0-64 0-48 48 0 16 0 0-17.9-52.3-58.8-11-12.3-1.1-16.5C394.8 107.4 332.3 48 256 48l-32 0C126.8 48 48 127 48 224.2c0 46.1 18.1 90.5 50.3 123.4l13.7 14zM312 192l-40 0 0 16c0 22.1-17.9 40-40 40l-8 0 0 48 0 24-48 0 0-24 0-48-16 0c-22.1 0-40-17.9-40-40l0-3.3c-14.1-6.2-24-20.3-24-36.7c0-22.1 17.9-40 40-40l.2 0c2-18 17.2-32 35.8-32c6.2 0 12.1 1.6 17.2 4.3C196 88.2 209.1 80 224 80s28 8.2 34.8 20.3c5.1-2.8 10.9-4.3 17.2-4.3c12.7 0 23.8 6.5 30.2 16.4c1.9-.3 3.8-.4 5.8-.4c22.1 0 40 17.9 40 40s-17.9 40-40 40z'
      
    ]
  };

  

  
  

  var faBars = {
    prefix: 'fasr',
    iconName: 'bars',
    icon: [
      448,
      512,
      ["navicon"],
      'f0c9',
      
      'M0 64l448 0 0 48L0 112 0 64zM0 224l448 0 0 48L0 272l0-48zM448 384l0 48L0 432l0-48 448 0z'
      
    ]
  };

  
    var faNavicon = faBars;
  

  
  

  var faLocationDot = {
    prefix: 'fasr',
    iconName: 'location-dot',
    icon: [
      384,
      512,
      ["map-marker-alt"],
      'f3c5',
      
      'M336 192c0-79.5-64.5-144-144-144S48 112.5 48 192c0 16.3 7.7 42 24.7 75.4c16.4 32.2 38.8 66.4 62.1 98.3c20.3 27.9 40.7 53.3 57.2 73.1c16.5-19.8 36.9-45.2 57.2-73.1c23.2-31.9 45.6-66.2 62.1-98.3C328.3 234 336 208.3 336 192zm48 0c0 83.1-105.6 219-160.2 283.6C204.8 498.1 192 512 192 512s-12.8-13.9-31.8-36.4C105.6 411 0 275.1 0 192C0 86 86 0 192 0S384 86 384 192zm-160 0a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm-112 0a80 80 0 1 1 160 0 80 80 0 1 1 -160 0z'
      
    ]
  };

  
    var faMapMarkerAlt = faLocationDot;
  

  
  

  var faCodeFork = {
    prefix: 'fasr',
    iconName: 'code-fork',
    icon: [
      448,
      512,
      [],
      'e13b',
      
      'M112 48l0 64-64 0 0-64 64 0zM48 0L0 0 0 48l0 64 0 48 48 0 8 0 0 32c0 48.6 39.4 88 88 88l56 0 0 72-8 0-48 0 0 48 0 64 0 48 48 0 64 0 48 0 0-48 0-64 0-48-48 0-8 0 0-72 56 0c48.6 0 88-39.4 88-88l0-32 8 0 48 0 0-48 0-64 0-48L400 0 336 0 288 0l0 48 0 64 0 48 48 0 8 0 0 32c0 22.1-17.9 40-40 40l-160 0c-22.1 0-40-17.9-40-40l0-32 8 0 48 0 0-48 0-64 0-48L112 0 48 0zM400 48l0 64-64 0 0-64 64 0zM192 400l64 0 0 64-64 0 0-64z'
      
    ]
  };

  

  
  

  var faCompass = {
    prefix: 'fasr',
    iconName: 'compass',
    icon: [
      512,
      512,
      [129517],
      'f14e',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM128 384l64-192 192-64L320 320 128 384zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z'
      
    ]
  };

  

  
  

  var faCaretDown = {
    prefix: 'fasr',
    iconName: 'caret-down',
    icon: [
      320,
      512,
      [],
      'f0d7',
      
      'M272 192l48 0 0 48L160 384 0 240l0-48 48 0 224 0zM71.8 240L160 319.4 248.2 240 71.8 240z'
      
    ]
  };

  

  
  

  var faChartNetwork = {
    prefix: 'fasr',
    iconName: 'chart-network',
    icon: [
      640,
      512,
      [],
      'f78a',
      
      'M288 0L160 0l0 128 79.8 0L261 181.1c-34.9 21.3-60 57.1-67 98.9l-66 0 0-40L0 240 0 368l128 0 0-40 66 0c11.4 68.1 70.7 120 142 120c43.8 0 83-19.5 109.4-50.4l66.6 40 0 74.4 128 0 0-128-124 0-45.8-27.5c6.4-16.3 9.9-34 9.9-52.5c0-23.2-5.5-45.2-15.3-64.6L529.3 192 640 192l0-128L512 64l0 81.2-75.7 55.5C410.4 175.5 375 160 336 160c-10.5 0-20.6 1.1-30.5 3.2L288 119.4 288 0zm48 208a96 96 0 1 1 0 192 96 96 0 1 1 0-192z'
      
    ]
  };

  

  
  

  var faScrubber = {
    prefix: 'fasr',
    iconName: 'scrubber',
    icon: [
      512,
      512,
      [],
      'f2f8',
      
      'M464 256A208 208 0 1 0 48 256a208 208 0 1 0 416 0zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm256-64a64 64 0 1 1 0 128 64 64 0 1 1 0-128z'
      
    ]
  };

  

  
  

  var faBookOpenReader = {
    prefix: 'fasr',
    iconName: 'book-open-reader',
    icon: [
      512,
      512,
      ["book-reader"],
      'f5da',
      
      'M256 48a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm0 144A96 96 0 1 0 256 0a96 96 0 1 0 0 192zm0 48s-53.2-39.9-208-46.9c-15-.7-31-1.1-48-1.1l0 48L0 416l0 48c160 0 256 48 256 48s96-48 256-48l0-48 0-176 0-48c-17 0-33 .4-48 1.1C309.2 200.1 256 240 256 240zm208 1.1l0 176.3c-62.8 3.6-114.4 13.9-152.6 24.3c-11.7 3.2-22.2 6.4-31.4 9.5L280 282l4-3 .3-.2c.9-.6 2.9-1.7 6.1-3.3c6.4-3.2 17.9-8.2 35.3-13.5c28.4-8.5 73-17.7 138.2-20.9zm-232 210c-9.2-3-19.6-6.3-31.4-9.5C162.4 431.3 110.8 421 48 417.4l0-176.3c65.2 3.1 109.8 12.3 138.2 20.9c17.5 5.2 28.9 10.2 35.3 13.5c3.2 1.6 5.2 2.8 6.1 3.3l.3 .2 4 3 0 169.2z'
      
    ]
  };

  
    var faBookReader = faBookOpenReader;
  

  
  

  var faCaretUp = {
    prefix: 'fasr',
    iconName: 'caret-up',
    icon: [
      320,
      512,
      [],
      'f0d8',
      
      'M48 320L0 320l0-48L160 128 320 272l0 48-48 0L48 320zm200.2-48L160 192.6 71.8 272l176.5 0z'
      
    ]
  };

  

  
  

  var faArrowRightArrowLeft = {
    prefix: 'fasr',
    iconName: 'arrow-right-arrow-left',
    icon: [
      448,
      512,
      [8644,"exchange"],
      'f0ec',
      
      'M23.8 401.7l96 88 17.7 16.2 32.4-35.4-17.7-16.2L101.7 408 424 408l24 0 0-48-24 0-322.3 0 50.5-46.3 17.7-16.2-32.4-35.4-17.7 16.2-96 88L4.5 384l19.3 17.7zm400.4-256L443.5 128l-19.3-17.7-96-88L310.5 6.1 278.1 41.5l17.7 16.2L346.3 104 24 104 0 104l0 48 24 0 322.3 0-50.5 46.3-17.7 16.2 32.4 35.4 17.7-16.2 96-88z'
      
    ]
  };

  
    var faExchange = faArrowRightArrowLeft;
  

  
  

  var faMercury = {
    prefix: 'fasr',
    iconName: 'mercury',
    icon: [
      384,
      512,
      [9791],
      'f223',
      
      'M50.6 0C62 28.6 81.7 52.9 106.9 69.9C52.7 99.9 16 157.7 16 224c0 89.1 66.2 162.7 152 174.4l0 25.6-32 0-24 0 0 48 24 0 32 0 0 16 0 24 48 0 0-24 0-16 32 0 24 0 0-48-24 0-32 0 0-25.6c85.8-11.7 152-85.3 152-174.4c0-66.3-36.7-124.1-90.9-154.1C302.3 52.9 322 28.6 333.4 0L279.7 0C261.2 28.9 228.8 48 192 48s-69.2-19.1-87.7-48L50.6 0zM192 96a128 128 0 1 1 0 256 128 128 0 1 1 0-256z'
      
    ]
  };

  

  
  

  var faGraduationCap = {
    prefix: 'fasr',
    iconName: 'graduation-cap',
    icon: [
      640,
      512,
      [127891,"mortar-board"],
      'f19d',
      
      'M640 176l-12.8 4.5-14.2 5L320 288 126.3 220.2 80 263l0 83.8c15.4 25.1 27.8 68.4 0 133.2L0 464s32.5-46.5 48-96.9L48 256l0-7 5.1-4.8 38.9-36L26.9 185.4l-14.2-5L0 176l0-32 12.8-4.5 14.2-5L320 32 613.1 134.6l14.2 5L640 144l0 32zM320 237.1L540.4 160 320 82.9 99.6 160l41.9 14.7 172.9-64.8 11.2 30-137 51.4 131.4 46zm-176.4 23l46.6 16.3-13 123.5c4.8 3.5 12.8 8 24.6 12.6C230 423.6 272 432 320 432s90-8.4 118.3-19.4c11.8-4.6 19.8-9.2 24.6-12.6l-13-123.5 46.6-16.3L512 408c0 35.3-86 72-192 72s-192-36.7-192-72l15.6-147.8zM467.4 396c0 0-.1 .1-.3 .4c.2-.3 .3-.4 .3-.4zm-294.8 0c0 0 .1 .1 .3 .4c-.2-.3-.3-.4-.3-.4z'
      
    ]
  };

  
    var faMortarBoard = faGraduationCap;
  

  
  

  var faTriangleExclamation = {
    prefix: 'fasr',
    iconName: 'triangle-exclamation',
    icon: [
      512,
      512,
      [9888,"exclamation-triangle","warning"],
      'f071',
      
      'M27.4 432L0 480l55.3 0 401.4 0 55.3 0-27.4-48L283.6 80.4 256 32 228.4 80.4 27.4 432zm401.9 0L82.7 432 256 128.7 429.3 432zM232 296l0 24 48 0 0-24 0-88-48 0 0 88zm48 104l0-48-48 0 0 48 48 0z'
      
    ]
  };

  
    var faExclamationTriangle = faTriangleExclamation;
  
    var faWarning = faTriangleExclamation;
  

  
  

  var faFlag = {
    prefix: 'fasr',
    iconName: 'flag',
    icon: [
      448,
      512,
      [61725,127988],
      'f024',
      
      'M48 24L48 0 0 0 0 24 0 64 0 350.5 0 400l0 88 0 24 48 0 0-24 0-100 80.3-20.1c41.1-10.3 84.6-5.5 122.5 13.4c44.2 22.1 95.5 24.8 141.7 7.4L448 368l0-298.3L448 16 400 40l-6.4 3.2c-46.3 23.2-100.8 23.2-147.1 0c-35.1-17.6-75.4-22-113.5-12.5L48 52l0-28zm0 77.5l96.6-24.2c27-6.7 55.5-3.6 80.4 8.8c54.9 27.4 118.7 29.7 175 6.8l0 241.8-24.4 9.1c-33.7 12.6-71.2 10.7-103.4-5.4c-48.2-24.1-103.3-30.1-155.6-17.1L48 338.5l0-237z'
      
    ]
  };

  

  
  

  var faStar = {
    prefix: 'fasr',
    iconName: 'star',
    icon: [
      576,
      512,
      [11088,61446],
      'f005',
      
      'M374.6 164L315.2 51.4 288.1 0 260.9 51.4 201.5 164 76.2 185.7l-57.3 9.9 40.5 41.7 88.7 91.2L130 454.4 121.7 512l52.2-25.7 114.2-56.1 114.2 56.1L454.4 512l-8.3-57.6L428 328.5l88.7-91.2 40.5-41.7-57.3-9.9L374.6 164zm84.8 63.4l-65.8 67.7L377.2 312l3.4 23.4L394 428.8l-84.7-41.7-21.2-10.4-21.2 10.4-84.7 41.7 13.4-93.4L199 312l-16.4-16.9-65.8-67.7 93-16.1 23.3-4 11-20.9 44.1-83.5 44.1 83.5 11 20.9 23.3 4 93 16.1z'
      
    ]
  };

  

  
  

  var faSunDust = {
    prefix: 'fasr',
    iconName: 'sun-dust',
    icon: [
      512,
      512,
      [],
      'f764',
      
      'M193.1 23.2L256 57.1l62.9-33.9L362 0l14.1 46.9 20.5 68.4s0 0 0 0l-38.6 38.6s0 0 0 0l-7.4-24.8L333 70.2 278.8 99.4 256 111.6 233.2 99.4 179 70.2l-17.7 59-7.4 24.8-24.8 7.4L70.2 179l29.2 54.2L111.6 256 99.4 278.8 70.2 333l59 17.7 24.8 7.4s0 0 0 0l-38.6 38.6s0 0 0 0L46.9 376.1 0 362l23.2-43.1L57.1 256 23.2 193.1 0 150l46.9-14.1 68.4-20.5 20.5-68.4L150 0l43.1 23.2zM256 144c30.9 0 58.9 12.5 79.2 32.8l-33.9 33.9C289.7 199.2 273.7 192 256 192c-35.3 0-64 28.7-64 64c0 17.7 7.2 33.7 18.7 45.3l-33.9 33.9C156.5 314.9 144 286.9 144 256c0-61.9 50.1-112 112-112zm192 16a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm-80 80a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm112 48a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM240 368a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm-80 80a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm192-32a32 32 0 1 1 0 64 32 32 0 1 1 0-64zM368 400a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 288a32 32 0 1 1 0 64 32 32 0 1 1 0-64z'
      
    ]
  };

  

  
  

  var faChevronLeft = {
    prefix: 'fasr',
    iconName: 'chevron-left',
    icon: [
      320,
      512,
      [9001],
      'f053',
      
      'M-1.9 256l17-17L207 47l17-17L257.9 64 241 81 65.9 256 241 431l17 17L224 481.9l-17-17L15 273l-17-17z'
      
    ]
  };

  

  
  

  var faStarShooting = {
    prefix: 'fasr',
    iconName: 'star-shooting',
    icon: [
      512,
      512,
      [127776],
      'e036',
      
      'M297 57L265 89l-17 17L214.1 72l17-17 32-32 17-17L313.9 40 297 57zM489 249l-32 32-17 17L406.1 264l17-17 32-32 17-17L505.9 232l-17 17zm17-209L489 57 361 185l-17 17L310.1 168l17-17L455 23l17-17L505.9 40zM220.2 198.2l33 66.9 73.8 10.7 59.8 8.7-43.3 42.2-53.4 52.1 12.6 73.5L313 512l-53.5-28.1-66-34.7-66 34.7L73.9 512l10.2-59.6 12.6-73.5L43.3 326.8 0 284.6l59.8-8.7 73.8-10.7 33-66.9L193.5 144l26.8 54.2zm26.1 114.4l-25-3.6-11.2-22.6-16.7-33.9-16.7 33.9L165.6 309l-25 3.6-37.4 5.4 27.1 26.4 18.1 17.6L144 387l-6.4 37.3 33.5-17.6 22.3-11.7 22.3 11.7 33.5 17.6L242.9 387l-4.3-24.9 18.1-17.6 27.1-26.4-37.4-5.4z'
      
    ]
  };

  

  
  

  var faLocationPin = {
    prefix: 'fasr',
    iconName: 'location-pin',
    icon: [
      384,
      512,
      ["map-marker"],
      'f041',
      
      'M311.3 267.4c-16.4 32.2-38.8 66.4-62.1 98.3c-20.3 27.9-40.7 53.3-57.2 73.1c-16.5-19.8-36.9-45.2-57.2-73.1c-23.2-31.9-45.6-66.2-62.1-98.3C55.7 234 48 208.3 48 192c0-79.5 64.5-144 144-144s144 64.5 144 144c0 16.3-7.7 42-24.7 75.4zM223.8 475.6C278.4 411 384 275.1 384 192C384 86 298 0 192 0S0 86 0 192c0 83.1 105.6 219 160.2 283.6C179.2 498.1 192 512 192 512s12.8-13.9 31.8-36.4z'
      
    ]
  };

  
    var faMapMarker = faLocationPin;
  

  
  

  var faBadgeCheck = {
    prefix: 'fasr',
    iconName: 'badge-check',
    icon: [
      512,
      512,
      [],
      'f336',
      
      'M200.3 81.5C210.9 61.5 231.9 48 256 48s45.1 13.5 55.7 33.5L321 99.1l19-5.8c21.6-6.6 46.1-1.4 63.1 15.7s22.3 41.5 15.7 63.1l-5.8 19 17.5 9.3c20 10.6 33.5 31.6 33.5 55.7s-13.5 45.1-33.5 55.7L412.9 321l5.8 19c6.6 21.6 1.4 46.1-15.7 63.1s-41.5 22.3-63.1 15.7l-19-5.8-9.3 17.5c-10.6 20-31.6 33.5-55.7 33.5s-45.1-13.5-55.7-33.5L191 412.9l-19 5.8c-21.6 6.6-46.1 1.4-63.1-15.7S86.6 361.6 93.2 340l5.8-19-17.5-9.3C61.5 301.1 48 280.1 48 256s13.5-45.1 33.5-55.7L99.1 191l-5.8-19c-6.6-21.6-1.4-46.1 15.7-63.1S150.4 86.6 172 93.2l19 5.8 9.3-17.5zM256 0c-35.9 0-67.8 17-88.1 43.4c-33-4.3-67.6 6.2-93 31.6s-35.9 60-31.6 93C17 188.2 0 220.1 0 256s17 67.8 43.4 88.1c-4.3 33 6.2 67.6 31.6 93s60 35.9 93 31.6C188.2 495 220.1 512 256 512s67.8-17 88.1-43.4c33 4.3 67.6-6.2 93-31.6s35.9-60 31.6-93C495 323.8 512 291.9 512 256s-17-67.8-43.4-88.1c4.3-33-6.2-67.6-31.6-93s-60-35.9-93-31.6C323.8 17 291.9 0 256 0zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  

  
  

  var faChevronDown = {
    prefix: 'fasr',
    iconName: 'chevron-down',
    icon: [
      512,
      512,
      [],
      'f078',
      
      'M256 417.9l17-17L465 209l17-17L448 158.1l-17 17-175 175L81 175l-17-17L30.1 192l17 17L239 401l17 17z'
      
    ]
  };

  

  
  

  var faCircleCaretLeft = {
    prefix: 'fasr',
    iconName: 'circle-caret-left',
    icon: [
      512,
      512,
      ["caret-circle-left"],
      'f32e',
      
      'M48 256a208 208 0 1 1 416 0A208 208 0 1 1 48 256zm464 0A256 256 0 1 0 0 256a256 256 0 1 0 512 0zM272 384l32 0 0-256-32 0L144 256 272 384z'
      
    ]
  };

  
    var faCaretCircleLeft = faCircleCaretLeft;
  

  
  

  var faList = {
    prefix: 'fasr',
    iconName: 'list',
    icon: [
      512,
      512,
      ["list-squares"],
      'f03a',
      
      'M112 48L16 48l0 96 96 0 0-96zm72 24l-24 0 0 48 24 0 304 0 24 0 0-48-24 0L184 72zm0 160l-24 0 0 48 24 0 304 0 24 0 0-48-24 0-304 0zm0 160l-24 0 0 48 24 0 304 0 24 0 0-48-24 0-304 0zM16 208l0 96 96 0 0-96-96 0zm96 160l-96 0 0 96 96 0 0-96z'
      
    ]
  };

  
    var faListSquares = faList;
  

  
  

  var faSolarSystem = {
    prefix: 'fasr',
    iconName: 'solar-system',
    icon: [
      512,
      512,
      [],
      'e02f',
      
      'M464 256c0 42.1-12.5 81.3-34 114.1c-4.4-1.3-9.1-2.1-14-2.1c-26.5 0-48 21.5-48 48s21.5 48 48 48s48-21.5 48-48c0-3.2-.3-6.4-.9-9.4C493.8 364.3 512 312.3 512 256C512 114.6 397.4 0 256 0c-42.3 0-82.1 10.2-117.2 28.4c14.2 9 25.3 22.3 31.6 38C196.5 54.6 225.5 48 256 48c114.9 0 208 93.1 208 208zM256 464C141.1 464 48 370.9 48 256c0-42.1 12.5-81.3 34-114.1c4.4 1.3 9.1 2.1 14 2.1c26.5 0 48-21.5 48-48s-21.5-48-48-48S48 69.5 48 96c0 3.2 .3 6.4 .9 9.4C18.2 147.7 0 199.7 0 256C0 397.4 114.6 512 256 512c42.1 0 81.7-10.1 116.8-28.1c-14.1-9.1-25.1-22.4-31.3-38.2c-26.1 11.8-55 18.3-85.5 18.3zm96-264c.3 0 .7 0 1 0c9.5 16.5 15 35.6 15 56c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c20.4 0 39.5 5.5 56 15c0 .3 0 .7 0 1c0 22.1 17.9 40 40 40zm64 56c0-31.8-9.3-61.3-25.2-86.2c.8-3.1 1.2-6.4 1.2-9.8c0-22.1-17.9-40-40-40c-3.4 0-6.6 .4-9.8 1.2C317.3 105.2 287.8 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160zM256 336l33.9-33.9 12.1-12.1L336 256l-33.9-33.9-12.1-12.1L256 176l-33.9 33.9-12.1 12.1L176 256l33.9 33.9 12.1 12.1L256 336zm0-67.9L243.9 256 256 243.9 268.1 256 256 268.1z'
      
    ]
  };

  

  
  

  var faToriiGate = {
    prefix: 'fasr',
    iconName: 'torii-gate',
    icon: [
      512,
      512,
      [9961],
      'f6a1',
      
      'M416 80l7.8 0 7.4-2.5L464 66.6l0 37.4-32 24-152 0-48 0L80 128 48 104l0-37.4L80.8 77.5 88.2 80 96 80l320 0zM232 176l0 64-120 0 0-64 120 0zM64 288l0 200 0 24 48 0 0-24 0-200 144 0 144 0 0 200 0 24 48 0 0-24 0-200 40 0 24 0 0-48-24 0-40 0 0-64 64-48 0-77.4L512 0 464 16 416 32 96 32 48 16 0 0 0 50.6 0 128l64 48 0 64-40 0L0 240l0 48 24 0 40 0zm336-48l-120 0 0-64 120 0 0 64z'
      
    ]
  };

  

  
  

  var faCircleCheck = {
    prefix: 'fasr',
    iconName: 'circle-check',
    icon: [
      512,
      512,
      [61533,"check-circle"],
      'f058',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM369 209l17-17L352 158.1l-17 17-111 111-47-47-17-17L126.1 256l17 17 64 64 17 17 17-17L369 209z'
      
    ]
  };

  
    var faCheckCircle = faCircleCheck;
  

  
  

  var faXmark = {
    prefix: 'fasr',
    iconName: 'xmark',
    icon: [
      384,
      512,
      [215,10005,10006,10060,128473,"close","multiply","remove","times"],
      'f00d',
      
      'M345 137l17-17L328 86.1l-17 17-119 119L73 103l-17-17L22.1 120l17 17 119 119L39 375l-17 17L56 425.9l17-17 119-119L311 409l17 17L361.9 392l-17-17-119-119L345 137z'
      
    ]
  };

  
    var faClose = faXmark;
  
    var faMultiply = faXmark;
  
    var faRemove = faXmark;
  
    var faTimes = faXmark;
  

  
  

  var faSquareCaretLeft = {
    prefix: 'fasr',
    iconName: 'square-caret-left',
    icon: [
      448,
      512,
      ["caret-square-left"],
      'f191',
      
      'M48 432l352 0 0-352L48 80l0 352zM0 480l0-48L0 80 0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480zm256-96L128 256 256 128l32 0 0 256-32 0z'
      
    ]
  };

  
    var faCaretSquareLeft = faSquareCaretLeft;
  

  
  

  var faBookmark = {
    prefix: 'fasr',
    iconName: 'bookmark',
    icon: [
      384,
      512,
      [61591,128278],
      'f02e',
      
      'M192 344.4l24.2 14.1L336 428.4 336 48 48 48l0 380.4 119.8-69.9L192 344.4zM48 484L0 512l0-55.6L0 48 0 0 48 0 336 0l48 0 0 48 0 408.4 0 55.6-48-28L192 400 48 484z'
      
    ]
  };

  

  
  

  var faChartMixedUpCircleCurrency = {
    prefix: 'fasr',
    iconName: 'chart-mixed-up-circle-currency',
    icon: [
      576,
      512,
      [],
      'e5d8',
      
      'M384 0l24 0L520 0l24 0 0 24 0 112 0 24-48 0 0-24 0-54.1-1 .8-160 128-15.1 12.1-15-12.2L191.3 118.3l-137 101L34.9 233.6 6.4 194.9l19.3-14.2 152-112 15-11 14.4 11.7 113 91.8L461.6 48 408 48l-24 0 0-48zM200 264l-16 0 0 176 16 0 0-176zm-16-40l16 0 40 0 0 40 0 176 0 40-40 0-16 0-40 0 0-40 0-176 0-40 40 0zM72 360l-16 0 0 80 16 0 0-80zM56 320l16 0 40 0 0 40 0 80 0 40-40 0-16 0-40 0 0-40 0-80 0-40 40 0zm232 48a144 144 0 1 1 288 0 144 144 0 1 1 -288 0zm118.6-25.4a35.9 35.9 0 1 1 50.7 50.7 35.9 35.9 0 1 1 -50.7-50.7zM467.3 426l25.3 25.3 22.6-22.6L490 403.3c13.2-21.6 13.2-49.1 0-70.7l25.3-25.3-22.6-22.6L467.3 310c-21.6-13.2-49.1-13.2-70.7 0l-25.3-25.3-22.6 22.6L374 332.7c-13.2 21.6-13.2 49.1 0 70.7l-25.3 25.3 22.6 22.6L396.7 426c21.6 13.2 49.1 13.2 70.7 0z'
      
    ]
  };

  

  
  

  var faHouse = {
    prefix: 'fasr',
    iconName: 'house',
    icon: [
      576,
      512,
      [63498,63500,127968,"home","home-alt","home-lg-alt"],
      'f015',
      
      'M303.5 13.7L288 .5 272.5 13.7l-264 224 31.1 36.6L64 253.5 64 488l0 24 24 0 400 0 24 0 0-24 0-234.5 24.5 20.8 31.1-36.6-264-224zM112 464l0-251.2L288 63.5 464 212.8 464 464l-80 0 0-168 0-24-24 0-144 0-24 0 0 24 0 168-80 0zm128 0l0-144 96 0 0 144-96 0z'
      
    ]
  };

  
    var faHome = faHouse;
  
    var faHomeAlt = faHouse;
  
    var faHomeLgAlt = faHouse;
  

  
  

  var faCheck = {
    prefix: 'fasr',
    iconName: 'check',
    icon: [
      448,
      512,
      [10003,10004],
      'f00c',
      
      'M448 130L431 147 177.5 399.2l-16.9 16.9-16.9-16.9L17 273.1 0 256.2l33.9-34 17 16.9L160.6 348.3 397.1 112.9l17-16.9L448 130z'
      
    ]
  };

  

  
  

  var faCalendar = {
    prefix: 'fasr',
    iconName: 'calendar',
    icon: [
      448,
      512,
      [128197,128198],
      'f133',
      
      'M152 24l0-24L104 0l0 24 0 40L0 64l0 80 0 48L0 464l0 48 48 0 352 0 48 0 0-48 0-272 0-48 0-80L344 64l0-40 0-24L296 0l0 24 0 40L152 64l0-40zM48 192l352 0 0 272L48 464l0-272z'
      
    ]
  };

  

  
  

  var faLifeRing = {
    prefix: 'fasr',
    iconName: 'life-ring',
    icon: [
      512,
      512,
      [],
      'f1cd',
      
      'M385.1 419.1C349.7 447.2 304.8 464 256 464s-93.7-16.8-129.1-44.9l80.4-80.4c14.3 8.4 31 13.3 48.8 13.3s34.5-4.8 48.8-13.3l80.4 80.4zm68.1 .2C489.9 374.9 512 318.1 512 256s-22.1-118.9-58.8-163.3L465 81l17-17L448 30.1 431 47 419.3 58.8C374.9 22.1 318.1 0 256 0S137.1 22.1 92.7 58.8L81 47l-17-17L30.1 64 47 81 58.8 92.7C22.1 137.1 0 193.9 0 256s22.1 118.9 58.8 163.3L47 431l-17 17L64 481.9l17-17 11.8-11.8C137.1 489.9 193.9 512 256 512s118.9-22.1 163.3-58.8L431 465l17 17L481.9 448l-17-17-11.8-11.8zm-34.1-34.1l-80.4-80.4c8.4-14.3 13.3-31 13.3-48.8s-4.8-34.5-13.3-48.8l80.4-80.4C447.2 162.3 464 207.2 464 256s-16.8 93.7-44.9 129.1zM385.1 92.9l-80.4 80.4c-14.3-8.4-31-13.3-48.8-13.3s-34.5 4.8-48.8 13.3L126.9 92.9C162.3 64.8 207.2 48 256 48s93.7 16.8 129.1 44.9zM173.3 304.8L92.9 385.1C64.8 349.7 48 304.8 48 256s16.8-93.7 44.9-129.1l80.4 80.4c-8.4 14.3-13.3 31-13.3 48.8s4.8 34.5 13.3 48.8zM208 256a48 48 0 1 1 96 0 48 48 0 1 1 -96 0z'
      
    ]
  };

  

  
  

  var faXmarkLarge = {
    prefix: 'fasr',
    iconName: 'xmark-large',
    icon: [
      448,
      512,
      [],
      'e59b',
      
      'M52.2 50.2l-17-17L1.3 67.2l17 17L190.1 256 18.2 427.8l-17 17 33.9 33.9 17-17L224 289.9 395.8 461.8l17 17 33.9-33.9-17-17L257.9 256 429.8 84.2l17-17L412.8 33.3l-17 17L224 222.1 52.2 50.2z'
      
    ]
  };

  

  
  

  var faGear = {
    prefix: 'fasr',
    iconName: 'gear',
    icon: [
      512,
      512,
      [9881,"cog"],
      'f013',
      
      'M328 0l14.6 66.8c11.9 5.5 23.3 12 33.8 19.6l65.2-20.8 72 124.7-50.6 46.1c.6 6.4 .9 12.9 .9 19.5s-.3 13.1-.9 19.5l50.6 46.1-72 124.7-65.2-20.8c-10.6 7.5-21.9 14.1-33.8 19.6L328 512l-144 0-14.6-66.8c-11.9-5.5-23.3-12-33.8-19.6L70.3 446.4l-72-124.7 50.6-46.1c-.6-6.4-.9-12.9-.9-19.5s.3-13.1 .9-19.5L-1.7 190.4l72-124.7 65.2 20.8c10.6-7.5 21.9-14.1 33.8-19.6L184 0 328 0zm63 132.2l-22.9 7.3-19.5-13.9c-8.2-5.8-16.9-10.9-26-15.1l-21.8-10-5.1-23.4L289.4 48l-66.7 0-6.4 29.1-5.1 23.4-21.8 10c-9.2 4.2-17.9 9.3-26 15.1l-19.5 13.9L121 132.2l-28.4-9L59.2 180.9l22 20.1 17.7 16.1-2.2 23.8c-.5 5-.7 10-.7 15.1s.2 10.1 .7 15.1l2.2 23.8L81.2 311l-22 20.1 33.4 57.8 28.4-9 22.9-7.3 19.5 13.9c8.2 5.8 16.9 10.9 26 15.1l21.8 10 5.1 23.4 6.4 29.1 66.7 0 6.4-29.1 5.1-23.4 21.8-10c9.2-4.2 17.9-9.3 26-15.1l19.5-13.9 22.9 7.3 28.4 9 33.4-57.8L430.8 311l-17.7-16.1 2.2-23.8c.5-5 .7-10 .7-15.1s-.2-10.1-.7-15.1l-2.2-23.8L430.8 201l22.1-20.1-33.4-57.8-28.4 9zM304 256a48 48 0 1 0 -96 0 48 48 0 1 0 96 0zm-144 0a96 96 0 1 1 192 0 96 96 0 1 1 -192 0z'
      
    ]
  };

  
    var faCog = faGear;
  

  
  

  var faBadge = {
    prefix: 'fasr',
    iconName: 'badge',
    icon: [
      512,
      512,
      [],
      'f335',
      
      'M256 48c-24.1 0-45.1 13.5-55.7 33.5L191 99.1l-19-5.8c-21.6-6.6-46.1-1.4-63.1 15.7S86.6 150.4 93.2 172l5.8 19-17.5 9.3C61.5 210.9 48 231.9 48 256s13.5 45.1 33.5 55.7L99.1 321l-5.8 19c-6.6 21.6-1.4 46.1 15.7 63.1s41.5 22.3 63.1 15.7l19-5.8 9.3 17.5c10.6 20 31.6 33.5 55.7 33.5s45.1-13.5 55.7-33.5l9.3-17.5 19 5.8c21.6 6.6 46.1 1.4 63.1-15.7s22.3-41.5 15.7-63.1l-5.8-19 17.5-9.3c20-10.6 33.5-31.6 33.5-55.7s-13.5-45.1-33.5-55.7L412.9 191l5.8-19c6.6-21.6 1.4-46.1-15.7-63.1S361.6 86.6 340 93.2l-19 5.8-9.3-17.5C301.1 61.5 280.1 48 256 48zm-88.1-4.6C188.2 17 220.1 0 256 0s67.8 17 88.1 43.4c33-4.3 67.6 6.2 93 31.6s35.9 60 31.6 93C495 188.2 512 220.1 512 256s-17 67.8-43.4 88.1c4.3 33-6.2 67.6-31.6 93s-60 35.9-93 31.6C323.8 495 291.9 512 256 512s-67.8-17-88.1-43.4c-33 4.3-67.6-6.2-93-31.6s-35.9-60-31.6-93C17 323.8 0 291.9 0 256s17-67.8 43.4-88.1c-4.3-33 6.2-67.6 31.6-93s60-35.9 93-31.6z'
      
    ]
  };

  

  
  

  var faCircleUser = {
    prefix: 'fasr',
    iconName: 'circle-user',
    icon: [
      512,
      512,
      [62142,"user-circle"],
      'f2bd',
      
      'M464 256c0-114.9-93.1-208-208-208S48 141.1 48 256c0 60.2 25.6 114.5 66.5 152.5L144 320l224 0 29.5 88.5c40.9-38 66.5-92.2 66.5-152.5zM333.4 368l-154.8 0-23.3 70c29.8 16.6 64.2 26 100.7 26s70.9-9.4 100.7-26l-23.3-70zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zm216-56a40 40 0 1 0 80 0 40 40 0 1 0 -80 0zm40 88a88 88 0 1 1 0-176 88 88 0 1 1 0 176z'
      
    ]
  };

  
    var faUserCircle = faCircleUser;
  

  
  

  var faCircleExclamation = {
    prefix: 'fasr',
    iconName: 'circle-exclamation',
    icon: [
      512,
      512,
      ["exclamation-circle"],
      'f06a',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm24-384l-48 0 0 24 0 112 0 24 48 0 0-24 0-112 0-24zM232 368l48 0 0-48-48 0 0 48z'
      
    ]
  };

  
    var faExclamationCircle = faCircleExclamation;
  

  
  

  var faCrosshairsSimple = {
    prefix: 'fasr',
    iconName: 'crosshairs-simple',
    icon: [
      512,
      512,
      [],
      'e59f',
      
      'M462.6 232L392 232l-24 0 0 48 24 0 70.6 0c-11 95.7-86.9 171.6-182.6 182.6l0-22.6 0-48 0-24-48 0 0 24 0 48 0 22.6C136.3 451.6 60.4 375.7 49.4 280l70.6 0 24 0 0-48-24 0-70.6 0C60.4 136.3 136.3 60.4 232 49.4l0 70.6 0 24 48 0 0-24 0-70.6c95.7 11 171.6 86.9 182.6 182.6zM256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512z'
      
    ]
  };

  

  
  

  var faVenus = {
    prefix: 'fasr',
    iconName: 'venus',
    icon: [
      384,
      512,
      [9792],
      'f221',
      
      'M64 176a128 128 0 1 1 256 0A128 128 0 1 1 64 176zM216 350.4c85.8-11.7 152-85.3 152-174.4C368 78.8 289.2 0 192 0S16 78.8 16 176c0 89.1 66.2 162.7 152 174.4l0 49.6-48 0-24 0 0 48 24 0 48 0 0 40 0 24 48 0 0-24 0-40 48 0 24 0 0-48-24 0-48 0 0-49.6z'
      
    ]
  };

  

  
  

  var faUserPlus = {
    prefix: 'fasr',
    iconName: 'user-plus',
    icon: [
      640,
      512,
      [],
      'f234',
      
      'M304 128a80 80 0 1 0 -160 0 80 80 0 1 0 160 0zM65 464l318 0L348.5 352 99.5 352 65 464zM384 304l49.2 160L448 512l-50.2 0L50.2 512 0 512l14.8-48L64 304l160 0 160 0zM224 0a128 128 0 1 1 0 256A128 128 0 1 1 224 0zM504 336l0-24 0-64-64 0-24 0 0-48 24 0 64 0 0-64 0-24 48 0 0 24 0 64 64 0 24 0 0 48-24 0-64 0 0 64 0 24-48 0z'
      
    ]
  };

  

  
  

  var faArrowUpSquareTriangle = {
    prefix: 'fasr',
    iconName: 'arrow-up-square-triangle',
    icon: [
      576,
      512,
      ["sort-shapes-up-alt"],
      'f88b',
      
      'M368 80l96 0 0 96-96 0 0-96zM320 32l0 48 0 96 0 48 48 0 96 0 48 0 0-48 0-96 0-48-48 0-96 0-48 0zM160 33.3l-17 17-96 96-17 17L64 197.1l17-17 55-55L136 456l0 24 48 0 0-24 0-330.9 55 55 17 17 33.9-33.9-17-17-96-96-17-17zM296 480l55.4 0 129.2 0 55.4 0-27.7-48L443.7 320 416 272l-27.7 48L323.7 432 296 480zm156.9-48l-73.8 0L416 368.1 452.9 432z'
      
    ]
  };

  
    var faSortShapesUpAlt = faArrowUpSquareTriangle;
  

  
  

  var faSquareCaretRight = {
    prefix: 'fasr',
    iconName: 'square-caret-right',
    icon: [
      448,
      512,
      ["caret-square-right"],
      'f152',
      
      'M400 80L48 80l0 352 352 0 0-352zm48-48l0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32l48 0 352 0 48 0zM192 128L320 256 192 384l-32 0 0-256 32 0z'
      
    ]
  };

  
    var faCaretSquareRight = faSquareCaretRight;
  

  
  

  var faSquareCaretUp = {
    prefix: 'fasr',
    iconName: 'square-caret-up',
    icon: [
      448,
      512,
      ["caret-square-up"],
      'f151',
      
      'M48 80l0 352 352 0 0-352L48 80zM0 32l48 0 352 0 48 0 0 48 0 352 0 48-48 0L48 480 0 480l0-48L0 80 0 32zM96 288L224 160 352 288l0 32L96 320l0-32z'
      
    ]
  };

  
    var faCaretSquareUp = faSquareCaretUp;
  

  
  

  var faCrown = {
    prefix: 'fasr',
    iconName: 'crown',
    icon: [
      576,
      512,
      [128081],
      'f521',
      
      'M309 106c11.4-7 19-19.7 19-34c0-22.1-17.9-40-40-40s-40 17.9-40 40c0 14.4 7.6 27 19 34l-5.8 11.6L214 212.1 192 256l-38.3-30.7L89.1 173.7 72 160c5-6.7 8-15 8-24c0-22.1-17.9-40-40-40S0 113.9 0 136s17.9 40 40 40c.2 0 .5 0 .7 0l4.4 23.9L96 480l384 0 50.9-280.1 4.4-23.9c.2 0 .5 0 .7 0c22.1 0 40-17.9 40-40s-17.9-40-40-40s-40 17.9-40 40c0 9 3 17.3 8 24l-17.1 13.7-64.6 51.7L384 256l-22-43.9-47.2-94.4L309 106zM234.9 277.5L288 171.3l53.1 106.1 26.6 53.1L414 293.5l59.8-47.9L439.9 432l-303.9 0L102.2 245.6 162 293.5l46.4 37.1 26.6-53.1z'
      
    ]
  };

  

  
  

  var faCircleXmark = {
    prefix: 'fasr',
    iconName: 'circle-xmark',
    icon: [
      512,
      512,
      [61532,"times-circle","xmark-circle"],
      'f057',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm97.9-320L320 158.1l-17 17-47 47-47-47-17-17L158.1 192l17 17 47 47-47 47-17 17L192 353.9l17-17 47-47 47 47 17 17L353.9 320l-17-17-47-47 47-47 17-17z'
      
    ]
  };

  
    var faTimesCircle = faCircleXmark;
  
    var faXmarkCircle = faCircleXmark;
  

  
  

  var faMars = {
    prefix: 'fasr',
    iconName: 'mars',
    icon: [
      448,
      512,
      [9794],
      'f222',
      
      'M312 32l-24 0 0 48 24 0 54.1 0-83.7 83.7C252.8 141.3 215.9 128 176 128C78.8 128 0 206.8 0 304s78.8 176 176 176s176-78.8 176-176c0-39.9-13.3-76.8-35.7-106.3L400 113.9l0 54.1 0 24 48 0 0-24 0-112 0-24-24 0L312 32zM48 304a128 128 0 1 1 256 0A128 128 0 1 1 48 304z'
      
    ]
  };

  

  
  

  var faMagnifyingGlassPlus = {
    prefix: 'fasr',
    iconName: 'magnifying-glass-plus',
    icon: [
      512,
      512,
      ["search-plus"],
      'f00e',
      
      'M208 48a160 160 0 1 1 0 320 160 160 0 1 1 0-320zm0 368c48.8 0 93.7-16.8 129.1-44.9l124 124 17 17L512 478.1l-17-17-124-124C399.2 301.7 416 256.8 416 208C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416zm-24-96l48 0 0-24 0-64 64 0 24 0 0-48-24 0-64 0 0-64 0-24-48 0 0 24 0 64-64 0-24 0 0 48 24 0 64 0 0 64 0 24z'
      
    ]
  };

  
    var faSearchPlus = faMagnifyingGlassPlus;
  

  
  

  var faChevronRight = {
    prefix: 'fasr',
    iconName: 'chevron-right',
    icon: [
      320,
      512,
      [9002],
      'f054',
      
      'M321.9 256l-17 17L113 465l-17 17L62.1 448l17-17 175-175L79 81l-17-17L96 30.1l17 17L305 239l17 17z'
      
    ]
  };

  

  
  

  var faBullseyeArrow = {
    prefix: 'fasr',
    iconName: 'bullseye-arrow',
    icon: [
      512,
      512,
      [127919],
      'f648',
      
      'M361.5 218.4c4.2 11.8 6.5 24.4 6.5 37.6c0 61.9-50.1 112-112 112s-112-50.1-112-112s50.1-112 112-112c13.2 0 25.9 2.3 37.6 6.5l4.9-4.9-7.6-45.8C279.6 97.3 268 96 256 96C167.6 96 96 167.6 96 256s71.6 160 160 160s160-71.6 160-160c0-12-1.3-23.6-3.8-34.9l-45.8-7.6-4.9 4.9zm97.4-8.1c3.3 14.7 5 30 5 45.7c0 114.9-93.1 208-208 208S48 370.9 48 256S141.1 48 256 48c15.7 0 31 1.7 45.7 5l38.8-38.8C314 5 285.6 0 256 0C114.6 0 0 114.6 0 256S114.6 512 256 512s256-114.6 256-256c0-29.6-5-58-14.3-84.5L459 210.3zm-93.9-29.4L432 192l80-80L432 80 400 0 320 80l11.2 66.9L231 247 265 281 365.1 180.8z'
      
    ]
  };

  

  
  

  var faCircleHalfStroke = {
    prefix: 'fasr',
    iconName: 'circle-half-stroke',
    icon: [
      512,
      512,
      [9680,"adjust"],
      'f042',
      
      'M464 256c0-114.9-93.1-208-208-208l0 416c114.9 0 208-93.1 208-208zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256z'
      
    ]
  };

  
    var faAdjust = faCircleHalfStroke;
  

  
  

  var faRightToBracket = {
    prefix: 'fasr',
    iconName: 'right-to-bracket',
    icon: [
      512,
      512,
      ["sign-in-alt"],
      'f2f6',
      
      'M128 224l48 0 0-48 0-28.1L284.1 256 176 364.1l0-28.1 0-48-48 0-80 0 0-64 80 0zm190.1-1.9L192 96l-16 0-48 0 0 32 0 16 0 32-48 0-32 0L0 176l0 48 0 64 0 48 48 0 32 0 48 0 0 32 0 16 0 32 48 0 16 0L318.1 289.9 352 256l-33.9-33.9zM344 432l-24 0 0 48 24 0 144 0 24 0 0-24 0-400 0-24-24 0L344 32l-24 0 0 48 24 0 120 0 0 352-120 0z'
      
    ]
  };

  
    var faSignInAlt = faRightToBracket;
  

  
  

  var faChevronUp = {
    prefix: 'fasr',
    iconName: 'chevron-up',
    icon: [
      512,
      512,
      [],
      'f077',
      
      'M256 94.1l17 17L465 303l17 17L448 353.9l-17-17-175-175L81 337l-17 17L30.1 320l17-17L239 111l17-17z'
      
    ]
  };

  

  
  

  var faArrowsLeftRightToLine = {
    prefix: 'fasr',
    iconName: 'arrows-left-right-to-line',
    icon: [
      640,
      512,
      [],
      'e4ba',
      
      'M48 64l0 24 0 336 0 24L0 448l0-24L0 88 0 64l48 0zm209.9 88l-17 17-63 63 284.1 0-63-63-17-17L416 118.1l17 17L537 239l17 17-17 17L433 377l-17 17L382.1 360l17-17 63-63-284.1 0 63 63 17 17L224 393.9l-17-17L103 273l-17-17 17-17L207 135l17-17L257.9 152zM640 88l0 336 0 24-48 0 0-24 0-336 0-24 48 0 0 24z'
      
    ]
  };

  

  
  

  var faCaretLeft = {
    prefix: 'fasr',
    iconName: 'caret-left',
    icon: [
      256,
      512,
      [],
      'f0d9',
      
      'M192 144l0-48-48 0L0 256 144 416l48 0 0-48 0-224zM144 344.2L64.6 256 144 167.8l0 176.5z'
      
    ]
  };

  

  
  

  var faEye = {
    prefix: 'fasr',
    iconName: 'eye',
    icon: [
      576,
      512,
      [128065],
      'f06e',
      
      'M129.1 361.4C93.6 327.2 67.7 286.9 52.5 256c15.1-30.9 41-71.2 76.6-105.4C171.8 109.5 224.9 80 288 80s116.2 29.5 158.9 70.6c35.6 34.3 61.5 74.5 76.6 105.4c-15.1 30.9-41 71.2-76.6 105.4C404.2 402.5 351.1 432 288 432s-116.2-29.5-158.9-70.6zM288 480c158.4 0 258-149.3 288-224C546 181.3 446.4 32 288 32S30 181.3 0 256c30 74.7 129.6 224 288 224zm0-144c-44.2 0-80-35.8-80-80c0-5.4 .5-10.6 1.5-15.7L288 256l-15.7-78.5c5.1-1 10.3-1.5 15.7-1.5c44.2 0 80 35.8 80 80s-35.8 80-80 80zM160 256c0 70.7 57.3 128 128 128s128-57.3 128-128s-57.3-128-128-128c-8.6 0-17 .8-25.1 2.5c-50.3 10-90 49.5-100.3 99.7l-.1 .7c-1.6 8.1-2.5 16.5-2.5 25.1z'
      
    ]
  };

  

  
  

  var faUsersRays = {
    prefix: 'fasr',
    iconName: 'users-rays',
    icon: [
      640,
      512,
      [],
      'e593',
      
      'M40 6.1L6.1 40 23 57l56 56 17 17L129.9 96 113 79 57 23 40 6.1zm560 0L583 23 527 79l-17 17L544 129.9l17-17 56-56 17-17L600 6.1zM57 489l56-56 17-17L96 382.1 79 399 23 455l-17 17L40 505.9l17-17zm543 17L633.9 472l-17-17-56-56-17-17L510.1 416l17 17 56 56 17 17zM260.1 288L224 288l-20 80-12 48 49.5 0 157 0 49.5 0-12-48-20-80-36.1 0L320 288l-59.9 0zm1.4 48l117 0 8 32-133 0 8-32zm13.3-96a72 72 0 1 0 90.5-112.1A72 72 0 1 0 274.7 240zM320 160a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm200 96l-79 0 6.1 24.2L461 336l83 0-24-80zm-400 0L96 336l83 0L193 280.2 199 256l-79 0zm55.8-32a48 48 0 1 0 0-96 48 48 0 1 0 0 96zM512 176a48 48 0 1 0 -96 0 48 48 0 1 0 96 0z'
      
    ]
  };

  

  
  

  var faCamera = {
    prefix: 'fasr',
    iconName: 'camera',
    icon: [
      512,
      512,
      [62258,"camera-alt"],
      'f030',
      
      'M352 32l21.3 64L464 96l48 0 0 48 0 288 0 48-48 0L48 480 0 480l0-48L0 144 0 96l48 0 90.7 0L160 32l192 0zm21.3 112l-34.6 0-10.9-32.8L317.4 80 194.6 80l-10.4 31.2L173.3 144l-34.6 0L48 144l0 288 416 0 0-288-90.7 0zM256 176a112 112 0 1 1 0 224 112 112 0 1 1 0-224zm64 112a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z'
      
    ]
  };

  
    var faCameraAlt = faCamera;
  

  
  

  var faCircleCaretRight = {
    prefix: 'fasr',
    iconName: 'circle-caret-right',
    icon: [
      512,
      512,
      ["caret-circle-right"],
      'f330',
      
      'M464 256A208 208 0 1 1 48 256a208 208 0 1 1 416 0zM0 256a256 256 0 1 0 512 0A256 256 0 1 0 0 256zM240 128l-32 0 0 256 32 0L368 256 240 128z'
      
    ]
  };

  
    var faCaretCircleRight = faCircleCaretRight;
  

  
  

  var faCircleCaretUp = {
    prefix: 'fasr',
    iconName: 'circle-caret-up',
    icon: [
      512,
      512,
      ["caret-circle-up"],
      'f331',
      
      'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM128 272l0 32 256 0 0-32L256 144 128 272z'
      
    ]
  };

  
    var faCaretCircleUp = faCircleCaretUp;
  

  
  

  var faMagnifyingGlass = {
    prefix: 'fasr',
    iconName: 'magnifying-glass',
    icon: [
      512,
      512,
      [128269,"search"],
      'f002',
      
      'M368 208A160 160 0 1 0 48 208a160 160 0 1 0 320 0zM337.1 371.1C301.7 399.2 256.8 416 208 416C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208c0 48.8-16.8 93.7-44.9 129.1l124 124 17 17L478.1 512l-17-17-124-124z'
      
    ]
  };

  
    var faSearch = faMagnifyingGlass;
  

  
  

  var faArrowsTurnToDots = {
    prefix: 'fasr',
    iconName: 'arrows-turn-to-dots',
    icon: [
      512,
      512,
      [],
      'e4c1',
      
      'M255 31l-80 80-17 17 17 17 80 80 17 17L305.9 208l-17-17-39-39L464 152l0 80 0 24 48 0 0-24 0-104 0-24-24 0-238.1 0 39-39 17-17L272 14.1 255 31zM257 287l-17-17L206.1 304l17 17 39 39L24 360 0 360l0 24L0 488l0 24 48 0 0-24 0-80 214.1 0-39 39-17 17L240 497.9l17-17 80-80 17-17-17-17-80-80zm255 97a64 64 0 1 0 -128 0 64 64 0 1 0 128 0zM64 64a64 64 0 1 0 0 128A64 64 0 1 0 64 64z'
      
    ]
  };

  

  
  

  var faCircleCaretDown = {
    prefix: 'fasr',
    iconName: 'circle-caret-down',
    icon: [
      512,
      512,
      ["caret-circle-down"],
      'f32d',
      
      'M256 48a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm0 464A256 256 0 1 1 256 0a256 256 0 1 1 0 512zM128 240l0-32 256 0 0 32L256 368 128 240z'
      
    ]
  };

  
    var faCaretCircleDown = faCircleCaretDown;
  

  
  

  var faCaretRight = {
    prefix: 'fasr',
    iconName: 'caret-right',
    icon: [
      256,
      512,
      [],
      'f0da',
      
      'M64 144l0-48 48 0L256 256 112 416l-48 0 0-48 0-224zm48 200.2L191.4 256 112 167.8l0 176.5z'
      
    ]
  };

  

  
  

  var faSquareCaretDown = {
    prefix: 'fasr',
    iconName: 'square-caret-down',
    icon: [
      448,
      512,
      ["caret-square-down"],
      'f150',
      
      'M48 432L48 80l352 0 0 352L48 432zM0 480l48 0 352 0 48 0 0-48 0-352 0-48-48 0L48 32 0 32 0 80 0 432l0 48zM96 224L224 352 352 224l0-32L96 192l0 32z'
      
    ]
  };

  
    var faCaretSquareDown = faSquareCaretDown;
  

  
  

  var faEnvelope = {
    prefix: 'fasr',
    iconName: 'envelope',
    icon: [
      512,
      512,
      [9993,61443,128386],
      'f0e0',
      
      'M48 150.8l208 143 208-143 0-38.8L48 112l0 38.8zM464 209L256 352 48 209l0 191 416 0 0-191zM0 400L0 176l0-64L0 64l48 0 416 0 48 0 0 48 0 64 0 224 0 48-48 0L48 448 0 448l0-48z'
      
    ]
  };

  

  
  

  var faLayerPlus = {
    prefix: 'fasr',
    iconName: 'layer-plus',
    icon: [
      576,
      512,
      ["layer-group-plus"],
      'f5ff',
      
      'M484 24l0 36 36 0 20 0 0 40-20 0-36 0 0 36 0 20-40 0 0-20 0-36-36 0-20 0 0-40 20 0 36 0 0-36 0-20 40 0 0 20zM118.2 256L288 331.5 457.8 256 288 180.5 118.2 256zM288 128L516.9 229.7 576 256l-59.1 26.3L288 384 59.1 282.3 0 256l59.1-26.3L288 128zM104.6 337.5l59.1 26.3L118.2 384 288 459.5 457.8 384l-45.5-20.2 59.1-26.3 45.5 20.2L576 384l-59.1 26.3L288 512 59.1 410.3 0 384l59.1-26.3 45.5-20.2z'
      
    ]
  };

  
    var faLayerGroupPlus = faLayerPlus;
  



export {

  faCircleInfo,
  
  faInfoCircle,
  

  faLightbulbOn,
  

  faArrowDownTriangleSquare,
  
  faSortShapesDown,
  

  faCircleDot,
  
  faDotCircle,
  

  faHeadSideBrain,
  

  faBars,
  
  faNavicon,
  

  faLocationDot,
  
  faMapMarkerAlt,
  

  faCodeFork,
  

  faCompass,
  

  faCaretDown,
  

  faChartNetwork,
  

  faScrubber,
  

  faBookOpenReader,
  
  faBookReader,
  

  faCaretUp,
  

  faArrowRightArrowLeft,
  
  faExchange,
  

  faMercury,
  

  faGraduationCap,
  
  faMortarBoard,
  

  faTriangleExclamation,
  
  faExclamationTriangle,
  
  faWarning,
  

  faFlag,
  

  faStar,
  

  faSunDust,
  

  faChevronLeft,
  

  faStarShooting,
  

  faLocationPin,
  
  faMapMarker,
  

  faBadgeCheck,
  

  faChevronDown,
  

  faCircleCaretLeft,
  
  faCaretCircleLeft,
  

  faList,
  
  faListSquares,
  

  faSolarSystem,
  

  faToriiGate,
  

  faCircleCheck,
  
  faCheckCircle,
  

  faXmark,
  
  faClose,
  
  faMultiply,
  
  faRemove,
  
  faTimes,
  

  faSquareCaretLeft,
  
  faCaretSquareLeft,
  

  faBookmark,
  

  faChartMixedUpCircleCurrency,
  

  faHouse,
  
  faHome,
  
  faHomeAlt,
  
  faHomeLgAlt,
  

  faCheck,
  

  faCalendar,
  

  faLifeRing,
  

  faXmarkLarge,
  

  faGear,
  
  faCog,
  

  faBadge,
  

  faCircleUser,
  
  faUserCircle,
  

  faCircleExclamation,
  
  faExclamationCircle,
  

  faCrosshairsSimple,
  

  faVenus,
  

  faUserPlus,
  

  faArrowUpSquareTriangle,
  
  faSortShapesUpAlt,
  

  faSquareCaretRight,
  
  faCaretSquareRight,
  

  faSquareCaretUp,
  
  faCaretSquareUp,
  

  faCrown,
  

  faCircleXmark,
  
  faTimesCircle,
  
  faXmarkCircle,
  

  faMars,
  

  faMagnifyingGlassPlus,
  
  faSearchPlus,
  

  faChevronRight,
  

  faBullseyeArrow,
  

  faCircleHalfStroke,
  
  faAdjust,
  

  faRightToBracket,
  
  faSignInAlt,
  

  faChevronUp,
  

  faArrowsLeftRightToLine,
  

  faCaretLeft,
  

  faEye,
  

  faUsersRays,
  

  faCamera,
  
  faCameraAlt,
  

  faCircleCaretRight,
  
  faCaretCircleRight,
  

  faCircleCaretUp,
  
  faCaretCircleUp,
  

  faMagnifyingGlass,
  
  faSearch,
  

  faArrowsTurnToDots,
  

  faCircleCaretDown,
  
  faCaretCircleDown,
  

  faCaretRight,
  

  faSquareCaretDown,
  
  faCaretSquareDown,
  

  faEnvelope,
  

  faLayerPlus,
  
  faLayerGroupPlus,
  

};
